<template>
    <div style="max-height: 450px;overflow-y: auto">
      <div style="height: 30px;color: #101010;text-align: center;font-size: 18px">
        <span>家庭设备</span>
      </div>
      <div>
        <el-table :data="homeDeviceTable" border style="width: 100%;font-size: 16px" highlight-current-row
                  :header-cell-style="getBackgroundColor" size="small">
          <el-table-column type="index" label="序号" width="55" align="center">
          </el-table-column>
          <el-table-column label="设备类型" min-width="95" align="center">
            <template slot-scope="scope">
              <span>{{getDeviceType(scope.row.devicetype)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备编号" min-width="130" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.devicetype !== 700">
                {{scope.row.deviceid}}
              </div>
              <div v-else>
                <el-tooltip placement="top" effect="dark">
                  <div slot="content">
                    <span style="font-size: 14px">版本号：</span>
                    <span style="font-size: 14px">{{scope.row.ver}}</span><br>
                    <span style="font-size: 14px">雷达监测结果：</span>
                    <span style="font-size: 14px" v-if="scope.row.radarstaus === 'tx'">休息</span>
                    <span style="font-size: 14px" v-if="scope.row.radarstaus === 'out'">动作</span><br>
                    <span style="font-size: 14px">雷达监测时间：</span>
                    <span style="font-size: 14px">{{scope.row.radartime}}</span><br>
                  </div>
                  <div>
                    <img style="vertical-align: sub;width: 20px;height: 20px"
                         src="../../../../../static/tableIcon/lie.png"
                         v-if="scope.row.radarstaus === 'tx'">
                    <img style="vertical-align: sub;width: 20px;height: 20px"
                         src="../../../../../static/tableIcon/walk.png"
                         v-if="scope.row.radarstaus === 'out'">
                    <span>{{scope.row.deviceid}}</span>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="simcardno" label="设备号码" min-width="100" align="center"></el-table-column>
          <el-table-column prop="last_online" label="最后在线时间" min-width="140" align="center"></el-table-column>
          <el-table-column prop="h_installlocation" label="安装位置" min-width="75" align="center"></el-table-column>
          <el-table-column align="center" label="操作" width="70">
            <template slot-scope="scope">
              <i v-if="scope.row.devicetype === 700" style="cursor: pointer; font-size: 18px;color: blue" title="设置设备" class="el-icon-s-tools" @click="openList(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="height: 30px;color: #101010;text-align: center;margin-top: 20px;font-size: 18px">
        <span>个人设备</span>
      </div>
      <div>
        <el-table :data="watchesTable" border style="width: 100%;font-size: 16px" highlight-current-row
                  :header-cell-style="getBackgroundColor" size="small">
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column label="设备类型" min-width="95" align="center">
            <template slot-scope="scope">
              <span>{{getDeviceType(scope.row.devicetype)}}</span>
            </template>
          </el-table-column>
          <el-table-column  prop="deviceid" label="设备编号" min-width="130" align="center"></el-table-column>
          <el-table-column prop="simcardno" label="设备号码" min-width="100" align="center"></el-table-column>
          <el-table-column prop="last_online" label="最后在线时间" min-width="140" align="center"></el-table-column>
          <el-table-column prop="p_name" label="使用者" min-width="75" align="center"></el-table-column>
          <el-table-column align="center" label="操作" width="70">
            <template slot-scope="scope">
              <i v-if="scope.row.devicetype === 300 || scope.row.devicetype === 350 || scope.row.devicetype === 901"
                 title="历史轨迹"
                 style="cursor: pointer; font-size: 18px;"
                 class="el-icon-delete-location" @click="openTrackMap(scope.row)"></i>
              <i v-if="scope.row.devicetype === 311 || scope.row.devicetype === 312 || scope.row.devicetype === 313"
                 style="cursor: pointer; font-size: 18px;color: blue" title="设备设置" class="el-icon-s-tools" @click="openList(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="height: 20px"></div>
      <!--子机、语音通知、电话本、fm频率设置-->
      <el-dialog :title="listTitle" :visible.sync="listShow" v-if="listShow"
        width="750px" :show-close="true" :close-on-click-modal="false" center append-to-body>
        <list-tabs v-model="listShow" :listObj="listObj"></list-tabs>
      </el-dialog>
      <!--9-电话本、10-白名单、11-发送消息、12-SOS报警电话、13-310闹钟提醒、14-311|313定时测量心率血氧、15-407 752滞留时长、22-701SOS号码、23-701按键号码-->
      <el-dialog :visible.sync="listShow310" v-if="listShow310" width="850px" :close-on-click-modal="true" center class="all-open" append-to-body>
        <div class="title-top-alarm">
          <div><span>{{ listTitle }}</span></div>
          <div class="line-title"></div>
        </div>
        <list-tabs-watch310 v-model="listShow310" :listObj="listObj"></list-tabs-watch310>
      </el-dialog>
      <el-dialog :visible.sync="trackShow" v-if="trackShow" width="900px"
        :close-on-click-modal="false" top="10vh" class="all-open" append-to-body>
        <div class="title-top-alarm">
          <div><span>历史轨迹</span></div>
          <div class="line-title"></div>
        </div>
        <div>
          <history-track v-model="trackShow" :trackObj="trackObj"></history-track>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import subList from '../../childComponents/subList'
import didVoiceDetails from '../../childComponents/didVoiceDetails'
import telBook from '../../childComponents/telBook'
import {querybinddevicebyhome} from '../../../../api/serviceObject'
import listTabs from '../../deviceComponents/listTabs'
import historyTrack from '../../deviceComponents/historyTrack'
import listTabsWatch310 from '../../deviceComponents/listTabsWatch310.vue'
export default {
  name: 'deviceDetails',
  components: {listTabsWatch310, subList, didVoiceDetails, telBook, listTabs, historyTrack},
  props: {
    deviceObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldpersons: [],
      homeDeviceTable: [],
      watchesTable: [],
      // 子机列表
      subShow: false,
      subTitle: '',
      deviceRow: {},
      // 语音通知
      openDetails: false,
      voiceObj: {
        device: '',
        org: [],
        community: [],
        home: [],
        push_type: 2
      },
      // 电话本
      telObj: {
        row: '',
        oldpersons: []
      },
      telShow: false,
      telTitle: '',
      // 设置设备
      listObj: {
        deviceRow: ''
      },
      listShow: false,
      listTitle: '',
      trackShow: false,
      trackObj: {
        deviceRow: ''
      },
      listShow310: false
    }
  },
  created () {
    /* 1、relationEdit.vue 家庭管理编辑 家庭 设备详情 2、quickOpen.vue快速操作 按钮 设备详情 3、callPhonePage.vue 客服关爱拨打电话弹窗页面 */
    this.golobleObject.updateTableDevice = this.bindDeviceBack
    console.log(99, this.deviceObj)
    if (this.deviceObj.hid !== '') {
      this.getDeviceByHids()
    }
  },
  methods: {
    getBackgroundColor () {
      return {backgroundColor: '#3D83F3', color: '#ffffff', borderColor: '#3D83F3'}
    },
    getDeviceType (type) {
      return this.commonType.getDeviceType(type)
    },
    // 查询设备
    getDeviceByHids () {
      let dtypes = this.commonType.getWatchDtype()
      this.homeDeviceTable = []
      this.watchesTable = []
      let data = {
        hids: [this.deviceObj.hid]
      }
      querybinddevicebyhome(data).then(res => {
        let arr = res.data.devices
        for (let i = 0; i < arr.length; i++) {
          if (dtypes.indexOf(arr[i].devicetype) > -1) {
            this.watchesTable.push(arr[i])
          } else {
            this.homeDeviceTable.push(arr[i])
          }
        }
      }).catch(() => {})
    },
    // 设置设备
    openList (row) {
      this.listTitle = '【' + row.deviceid + '】' + '设置'
      this.listObj.deviceRow = row
      if (row.devicetype === 311 || row.devicetype === 312 || row.devicetype === 313) {
        this.listShow310 = true
        return
      }
      this.listShow = true
    },
    openTelShow (row) {
      let arr = []
      for (let i = 0; i < this.oldpersons.length; i++) {
        if (row.hid === this.oldpersons[i].homeid) {
          arr.push(this.oldpersons[i])
        }
      }
      this.telObj.oldpersons = arr
      this.telObj.row = row
      this.telTitle = '【' + row.deviceid + '】' + '电话本'
      this.telShow = true
    },
    openViceShow (row) {
      this.voiceObj.device = row
      this.openDetails = true
    },
    openSubList (row) {
      this.deviceRow = row
      this.subTitle = '【' + row.deviceid + '】' + '子机列表'
      this.subShow = true
    },
    bindDeviceBack () {
      // console.log('绑定设备')
      this.getDeviceByHids()
    },
    openTrackMap (row) {
      this.trackObj.deviceRow = row
      this.trackShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/quick/components/deviceDetails.vue